import { render } from "./DocumentRequests.vue?vue&type=template&id=3105ac86"
import script from "./DocumentRequests.vue?vue&type=script&lang=js"
export * from "./DocumentRequests.vue?vue&type=script&lang=js"

import "./DocumentRequests.vue?vue&type=style&index=0&id=3105ac86&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__